var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFoodDiaryViewEntries(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;opacity:0;}.cls-2{fill:#ff75b0;}.cls-3{fill:#ffaed9;}.cls-4{fill:#fce3f1;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_45",
    "data-name": "Layer 45"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.95,
    y: 0.23,
    width: 600,
    height: 600
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.95,
    y: 0.23,
    width: 600,
    height: 600
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "food_diary_view_entries"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 219.51,
    y: 1.23,
    width: 380.96,
    height: 447.85,
    rx: 16.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 109.44,
    y: 75.89,
    width: 380.96,
    height: 447.85,
    rx: 16.79
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M381.43,270.36v314a17.06,17.06,0,0,1-17.26,16.84H17.72A17,17,0,0,1,.47,584.39V170.22a17,17,0,0,1,17.25-16.84H261.54a17.7,17.7,0,0,1,5.85,1l112.49,109A16.54,16.54,0,0,1,381.43,270.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M379.88,263.38H284.82a17.26,17.26,0,0,1-17.43-17.08V154.37Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 56.1,
    y: 372.65,
    width: 262.26,
    height: 36.54,
    rx: 12,
    transform: "translate(-2.97 1.43) rotate(-0.44)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 57.21,
    y: 519.3,
    width: 133.75,
    height: 36.54,
    rx: 12,
    transform: "translate(-4.08 0.96) rotate(-0.44)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 55.54,
    y: 299.57,
    width: 262.26,
    height: 36.54,
    rx: 12,
    transform: "translate(-2.41 1.43) rotate(-0.44)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 56.65,
    y: 445.74,
    width: 261.49,
    height: 36.54,
    rx: 12,
    transform: "translate(-3.52 1.44) rotate(-0.44)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodDiaryViewEntries);
export default __webpack_public_path__ + "static/media/food_diary_view_entries.de7a6d9b947933f2db7d6b168cd80793.svg";
export { ForwardRef as ReactComponent };